import { Space, Tooltip, Typography } from 'antd'
import { Fragment } from 'react'
import CIMSLink from 'components/CIMSLink'
import { getDeepestString } from 'utils/getReactNodeLength'
import { RenderedCellProps } from './types'

const RenderedCell: React.FC<RenderedCellProps> = ({
  id,
  children,
  hyperlink,
  note,
}) => {
  if (hyperlink)
    return (
      <CIMSLink external href={hyperlink} tooltip={note ?? undefined}>
        {children}
      </CIMSLink>
    )

  const split = getDeepestString(children)?.split('\n') ?? []
  return (
    <Tooltip title={note}>
      <Space size="small" direction="vertical">
        {split.map((value, i) => {
          const key = `${id}_${i}`
          let url
          try {
            url = new URL(value)
          } catch (err) {
            url = undefined
          }
          if (url)
            return (
              <CIMSLink key={key} external href={url.toString()}>
                {value}
              </CIMSLink>
            )
          const words = value.split(' ').map((word) => {
            try {
              if (word.endsWith(':')) return word
              const url = new URL(word)
              return { url, word }
            } catch (err) {
              return word
            }
          })
          return (
            <Typography.Text key={key}>
              {words.reduce((nodes, word, i) => {
                if (typeof word === 'string')
                  nodes.push(<Fragment key={`${word}_${i}`}>{word}</Fragment>)
                else {
                  const { word: label, url } = word
                  const key = `${label}_${i}`
                  nodes.push(
                    <CIMSLink key={key} external href={url.toString()}>
                      {label}
                    </CIMSLink>
                  )
                }
                nodes.push(<Fragment key={`space_${i}`}> </Fragment>)
                return nodes
              }, Array<React.ReactNode>())}
            </Typography.Text>
          )
        })}
      </Space>
    </Tooltip>
  )
}

export default RenderedCell
